const swipertuotekuvakaruselli = new Swiper('.tuotekuvakaruselli.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    autoHeight: false,

/*     thumbs: {
        swiper: swipertuotekuvakarusellithumbs,
      }, */

    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },


    // If we need pagination
    pagination: {
      el: '.swiper-pagination-tuotekaruselli',
      clickable: true,
    },

    // Navigation arrows
/*     navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }, */


/*     // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    }, */
  });
